import { buildTree as _buildTree } from '../../utils';
export function buildTree(idProp, parentIdProp) {
  return function (pipeline) {
    return pipeline.mapDataSource(function (rows) {
      return _buildTree(idProp, parentIdProp, rows);
    });
  };
}